import { isUndefined } from "lodash";
import { useMemo } from "react";
import { WeightIcon } from "@/shared/icons";

type Props = {
  weight: number;
  capacityWeight?: number;
};

export default function InventoryWeight({ weight, capacityWeight }: Props) {
  const fullPercent = Math.trunc((weight / capacityWeight) * 100);
  const color = useMemo(() => {
    const coef = weight / capacityWeight;
    if (coef < 0.3) return "#FFFFFF";
    if (coef < 0.7) return "#FF9E58";
    return "#FF4343";
  }, [capacityWeight, weight]);

  if (isUndefined(capacityWeight)) {
    return (
      <div className="flex items-center w-full gap-1">
        <WeightIcon size={20} />
        <div className="text-15 font-medium ml-2.5">Вес</div>
        <div className="text-14 font-bold ml-3.5">
          {Number(weight.toFixed(3))} <span className="text-white/50">KG</span>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center w-full gap-1">
        <WeightIcon size={20} color={isUndefined(capacityWeight) ? "#FFFFFF" : color} />
        <div className="text-15 font-medium ml-2.5">Вес</div>
        <div
          className="text-14 font-bold ml-3.5"
          style={{ color: isUndefined(capacityWeight) ? "#FFFFFF" : color }}
        >
          {Number(weight.toFixed(3))}{" "}
          {!isUndefined(capacityWeight) && (
            <span className="text-white/50">/ {capacityWeight} KG</span>
          )}
        </div>
      </div>
      {!isUndefined(capacityWeight) && (
        <div
          className="h-1 rounded-sm w-full overflow-clip"
          style={{ backgroundColor: `${color}24` }}
        >
          <div
            className="w-full h-full"
            style={{
              backgroundColor: color,
              clipPath: `polygon(0 0, ${fullPercent}% 0, ${fullPercent}% 100%, 0 100%)`,
            }}
          />
        </div>
      )}
    </div>
  );
}
